export default "__VITE_ASSET__CtneGyv8__"